export default __webpack_public_path__ + "static/chandrasekar1-9c8e272d72a6e60f86d06b0dce28475e.jpg";